import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

export const formatDate = (dateString: string) => {
  try {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return format(date, 'd MMMM', { locale: ru });
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

export const formatDateWithYear = (dateString: string) => {
  try {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return format(date, 'd MMMM y', { locale: ru });
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

export const formatTime = (dateString: string) => {
  try {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return format(date, 'HH:mm');
  } catch (error) {
    console.error('Error formatting time:', error);
    return '';
  }
};

export const formatDateWithTime = (dateString: string) => {
  try {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return format(date, 'd MMMM в HH:mm', { locale: ru });
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};
